var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"options":_vm.question.settings.options,"dir":"rtl","multiple":""},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"no-options",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('form.chooseFromList'))+"; ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }